/* =========================================================
   VS HEADER JS
   - Live Shopify predictive product search
   - Enter/search icon -> Shopify search results
   - Product image, title, price, compare price
   - Wishlist live count
   - Cart live count
   - Mobile drawer
   - Shopify Theme Editor safe re-init
   ========================================================= */

(function () {
  'use strict';

  var SEARCH_TIMER = 220;
  var searchControllers = new WeakMap();
  var searchTimers = new WeakMap();

  /* =========================================================
     SHOPIFY ROOT
  ========================================================= */

  function getRoot() {
    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  /* =========================================================
     SEARCH CONFIG
  ========================================================= */

  function getConfig(root) {
    var node = root.querySelector('[data-vs-search-config]');

    if (!node) {
      return {
        limit: 7,
        no_results: 'No products found',
        view_all: 'View all results'
      };
    }

    try {
      var config = JSON.parse(node.textContent || '{}');

      return {
        limit: Math.max(
          3,
          Math.min(10, Number(config.limit) || 7)
        ),
        no_results:
          config.no_results || 'No products found',
        view_all:
          config.view_all || 'View all results'
      };
    } catch (error) {
      return {
        limit: 7,
        no_results: 'No products found',
        view_all: 'View all results'
      };
    }
  }

  /* =========================================================
     ESCAPE HTML
  ========================================================= */

  function escapeHTML(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function escapeAttribute(value) {
    return escapeHTML(value);
  }

  /* =========================================================
     SEARCH URL
  ========================================================= */

  function getSearchURL(query) {
    return (
      getRoot() +
      'search?q=' +
      encodeURIComponent(query) +
      '&type=product'
    );
  }

  /* =========================================================
     PRICE FORMAT
  ========================================================= */
/* =========================================================
   PRICE FORMAT — SHOPIFY PREDICTIVE SEARCH
   Shopify search API price ko rupees mein return kar sakti hai.
   Isliye price ko dobara 100 se divide nahi karna hai.
========================================================= */

function formatPrice(value) {
  if (value == null || value === '') {
    return '';
  }

  // Numeric price ko number mein convert karo.
  var number = Number(value);

  // Invalid value ko safely handle karo.
  if (!Number.isFinite(number)) {
    return String(value);
  }

  // Price ko Indian currency format mein show karo.
  return '₹' + number.toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

  /* =========================================================
     PRODUCT IMAGE
  ========================================================= */

  function getProductImage(product) {
    if (!product) return '';

    if (product.featured_image) {
      if (
        typeof product.featured_image === 'string'
      ) {
        return product.featured_image;
      }

      if (product.featured_image.url) {
        return product.featured_image.url;
      }

      if (product.featured_image.src) {
        return product.featured_image.src;
      }
    }

    if (product.image) {
      if (typeof product.image === 'string') {
        return product.image;
      }

      if (product.image.url) {
        return product.image.url;
      }

      if (product.image.src) {
        return product.image.src;
      }
    }

    if (
      product.images &&
      product.images.length
    ) {
      var image = product.images[0];

      if (typeof image === 'string') {
        return image;
      }

      if (image && image.url) {
        return image.url;
      }

      if (image && image.src) {
        return image.src;
      }
    }

    return '';
  }

  /* =========================================================
     OPEN SEARCH
  ========================================================= */

  function openSearch(dropdown, input) {
    if (!dropdown) return;

    dropdown.classList.add('is-open');
    dropdown.setAttribute(
      'aria-hidden',
      'false'
    );

    if (input) {
      input.setAttribute(
        'aria-expanded',
        'true'
      );
    }
  }

  /* =========================================================
     CLOSE SEARCH
  ========================================================= */

  function closeSearch(dropdown, input) {
    if (!dropdown) return;

    dropdown.classList.remove(
      'is-open',
      'is-loading'
    );

    dropdown.setAttribute(
      'aria-hidden',
      'true'
    );

    if (input) {
      input.setAttribute(
        'aria-expanded',
        'false'
      );
    }
  }

  /* =========================================================
     RENDER SEARCH RESULTS
  ========================================================= */

  function renderResults(
    dropdown,
    input,
    results,
    query,
    products,
    config
  ) {
    dropdown.classList.remove(
      'is-loading'
    );

    /* ---------- NO RESULTS ---------- */

    if (!products.length) {
      results.innerHTML =
        '<div class="vs-header__predictive-empty">' +
          escapeHTML(config.no_results) +
          ' for <strong>"' +
          escapeHTML(query) +
          '"</strong>' +
        '</div>' +

        '<a class="vs-header__predictive-search-all" href="' +
          escapeAttribute(
            getSearchURL(query)
          ) +
        '">' +

          '<span>' +
            escapeHTML(config.view_all) +
          '</span>' +

          '<span>→</span>' +

        '</a>';

      openSearch(
        dropdown,
        input
      );

      return;
    }

    /* ---------- PRODUCTS ---------- */

    var html = '';

    products.forEach(
      function (product) {
        var title =
          product.title ||
          'Product';

        var url =
          product.url ||
          (
            product.handle
              ? getRoot() +
                'products/' +
                product.handle
              : '#'
          );

        var image =
          getProductImage(product);

        var price =
          formatPrice(product.price);

        var compare = '';

        if (
          product.compare_at_price != null &&
          product.price != null
        ) {
          var priceNumber =
            Number(product.price);

          var compareNumber =
            Number(
              product.compare_at_price
            );

          if (
            Number.isFinite(priceNumber) &&
            Number.isFinite(compareNumber) &&
            compareNumber > priceNumber
          ) {
            compare =
              formatPrice(
                product.compare_at_price
              );
          }
        }

        html +=
          '<a ' +
            'class="vs-header__predictive-product" ' +
            'href="' +
              escapeAttribute(url) +
            '">' +

            /* IMAGE */

            '<span class="vs-header__predictive-product-image">' +

              (
                image
                  ? '<img ' +
                      'src="' +
                        escapeAttribute(image) +
                      '" ' +
                      'alt="' +
                        escapeAttribute(title) +
                      '" ' +
                      'loading="lazy">'
                  : ''
              ) +

            '</span>' +

            /* INFO */

            '<span class="vs-header__predictive-product-info">' +

              '<span class="vs-header__predictive-product-title">' +
                escapeHTML(title) +
              '</span>' +

              '<span class="vs-header__predictive-product-meta">' +

                (
                  price
                    ? '<span class="vs-header__predictive-product-price">' +
                        escapeHTML(price) +
                      '</span>'
                    : ''
                ) +

                (
                  compare
                    ? '<span class="vs-header__predictive-product-compare">' +
                        escapeHTML(compare) +
                      '</span>'
                    : ''
                ) +

              '</span>' +

            '</span>' +

            /* ARROW */

            '<span class="vs-header__predictive-arrow">' +
              '→' +
            '</span>' +

          '</a>';
      }
    );

    /* ---------- VIEW ALL ---------- */

    html +=
      '<a class="vs-header__predictive-search-all" href="' +
        escapeAttribute(
          getSearchURL(query)
        ) +
      '">' +

        '<span>' +
          escapeHTML(
            config.view_all
          ) +
        '</span>' +

        '<span>→</span>' +

      '</a>';

    results.innerHTML = html;

    openSearch(
      dropdown,
      input
    );
  }

  /* =========================================================
     FETCH PREDICTIVE SEARCH
  ========================================================= */

  function fetchSuggestions(
    root,
    input,
    dropdown,
    results,
    query,
    config
  ) {
    var previous =
      searchControllers.get(input);

    if (previous) {
      previous.abort();
    }

    var controller =
      new AbortController();

    searchControllers.set(
      input,
      controller
    );

    dropdown.classList.add(
      'is-open',
      'is-loading'
    );

    dropdown.setAttribute(
      'aria-hidden',
      'false'
    );

    input.setAttribute(
      'aria-expanded',
      'true'
    );

    /* =====================================================
       SHOPIFY PREDICTIVE SEARCH API
    ===================================================== */

    var url =
      getRoot() +
      'search/suggest.json' +
      '?q=' +
      encodeURIComponent(query) +
      '&resources[type]=product' +
      '&resources[limit]=' +
      encodeURIComponent(config.limit) +
      '&resources[options][unavailable_products]=last';

    fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      signal: controller.signal
    })

      .then(
        function (response) {
          if (!response.ok) {
            throw new Error(
              'Predictive search request failed'
            );
          }

          return response.json();
        }
      )

      .then(
        function (data) {
          var products = [];

          if (
            data &&
            data.resources &&
            data.resources.results &&
            Array.isArray(
              data.resources.results.products
            )
          ) {
            products =
              data.resources.results.products;
          }

          renderResults(
            dropdown,
            input,
            results,
            query,
            products,
            config
          );
        }
      )

      .catch(
        function (error) {
          if (
            error &&
            error.name === 'AbortError'
          ) {
            return;
          }

          console.warn(
            'VS predictive search error:',
            error
          );

          dropdown.classList.remove(
            'is-loading'
          );

          results.innerHTML = '';

          closeSearch(
            dropdown,
            input
          );
        }
      );
  }

  /* =========================================================
     INIT PREDICTIVE SEARCH
  ========================================================= */

  function initPredictiveSearch(root) {

    /*
     * IMPORTANT FIX:
     *
     * Previously this was:
     *
     * root.querySelectorAll(
     *   '[data-vs-search-form]'
     * );
     *
     * But the Liquid forms don't have that
     * attribute.
     *
     * Now we use the existing class.
     */

    var forms =
      root.querySelectorAll(
        '.vs-header__search-form'
      );

    var config =
      getConfig(root);

    if (!forms.length) {
      console.warn(
        'VS Header: Search form not found.'
      );

      return;
    }

    forms.forEach(
      function (form) {

        if (
          form.dataset
            .vsSearchInitialized === 'true'
        ) {
          return;
        }

        form.dataset
          .vsSearchInitialized =
          'true';

        var input =
          form.querySelector(
            '[data-vs-search-input]'
          );

        if (!input) {
          return;
        }

        /* FIND SEARCH WRAPPER */

        var wrapper =
          form.closest(
            '.vs-header__search, .vs-header__mobile-search'
          );

        if (!wrapper) {
          return;
        }

        /* FIND DROPDOWN */

        var dropdown =
          wrapper.querySelector(
            '[data-vs-predictive-search]'
          );

        if (!dropdown) {
          console.warn(
            'VS Header: Predictive dropdown not found.'
          );

          return;
        }

        var results =
          dropdown.querySelector(
            '[data-vs-search-results]'
          );

        if (!results) {
          return;
        }

        /* =================================================
           INPUT
        ================================================= */

        input.addEventListener(
          'input',
          function () {

            var query =
              input.value.trim();

            var timer =
              searchTimers.get(input);

            if (timer) {
              window.clearTimeout(
                timer
              );
            }

            /* LESS THAN 2 CHARACTERS */

            if (
              query.length < 2
            ) {
              results.innerHTML = '';

              closeSearch(
                dropdown,
                input
              );

              return;
            }

            /* DEBOUNCE */

            searchTimers.set(
              input,
              window.setTimeout(
                function () {

                  fetchSuggestions(
                    root,
                    input,
                    dropdown,
                    results,
                    query,
                    config
                  );

                },
                SEARCH_TIMER
              )
            );
          }
        );

        /* =================================================
           FOCUS
        ================================================= */

        input.addEventListener(
          'focus',
          function () {

            var query =
              input.value.trim();

            if (
              query.length >= 2 &&
              results.innerHTML.trim()
            ) {
              openSearch(
                dropdown,
                input
              );
            }
          }
        );

        /* =================================================
           KEYBOARD
        ================================================= */

        input.addEventListener(
          'keydown',
          function (event) {

            /* ESC */

            if (
              event.key === 'Escape'
            ) {
              closeSearch(
                dropdown,
                input
              );

              return;
            }

            /* ENTER */

            if (
              event.key === 'Enter'
            ) {

              var query =
                input.value.trim();

              if (!query) {
                event.preventDefault();
                input.focus();
              }

              /*
               * If query exists:
               * allow normal Shopify form submit.
               */

            }
          }
        );

        /* =================================================
           FORM SUBMIT
        ================================================= */

        form.addEventListener(
          'submit',
          function (event) {

            var query =
              input.value.trim();

            if (!query) {
              event.preventDefault();

              input.focus();

              return;
            }

            /*
             * Keep normal Shopify search.
             *
             * Example:
             * /search?q=leno&type=product
             */

            closeSearch(
              dropdown,
              input
            );
          }
        );
      }
    );
  }

  /* =========================================================
     MOBILE DRAWER
  ========================================================= */

  function initDrawer(root) {

    var drawer =
      root.querySelector(
        '[data-vs-menu-drawer]'
      );

    var open =
      root.querySelector(
        '[data-vs-menu-open]'
      );

    var closeButtons =
      root.querySelectorAll(
        '[data-vs-menu-close]'
      );

    if (
      !drawer ||
      !open ||
      root.dataset
        .vsDrawerInitialized === 'true'
    ) {
      return;
    }

    root.dataset
      .vsDrawerInitialized =
      'true';

    function closeDrawer() {

      drawer.classList.remove(
        'is-open'
      );

      drawer.setAttribute(
        'aria-hidden',
        'true'
      );

      open.setAttribute(
        'aria-expanded',
        'false'
      );

      document.documentElement.classList.remove(
        'vs-header-menu-open'
      );
    }

    open.addEventListener(
      'click',
      function () {

        drawer.classList.add(
          'is-open'
        );

        drawer.setAttribute(
          'aria-hidden',
          'false'
        );

        open.setAttribute(
          'aria-expanded',
          'true'
        );

        document.documentElement.classList.add(
          'vs-header-menu-open'
        );
      }
    );

    closeButtons.forEach(
      function (button) {

        button.addEventListener(
          'click',
          function () {
            closeDrawer();
          }
        );

      }
    );

    drawer.addEventListener(
      'click',
      function (event) {

        if (
          event.target.closest('a')
        ) {
          closeDrawer();
        }

      }
    );

    root._vsCloseDrawer =
      closeDrawer;
  }

  /* =========================================================
     WISHLIST COUNT
  ========================================================= */

  function initWishlist(root) {

    var counters =
      root.querySelectorAll(
        '[data-vs-wishlist-count]'
      );

    if (
      !counters.length ||
      root.dataset
        .vsWishlistInitialized === 'true'
    ) {
      return;
    }

    root.dataset
      .vsWishlistInitialized =
      'true';

    function getCount() {

      try {

        var raw =
          localStorage.getItem(
            'vsx9_wishlist_v1'
          );

        if (!raw) {
          return 0;
        }

        var value =
          JSON.parse(raw);

        if (
          Array.isArray(value)
        ) {
          return value.length;
        }

        if (
          value &&
          Array.isArray(value.items)
        ) {
          return value.items.length;
        }

        if (
          value &&
          typeof value === 'object'
        ) {
          return Object.keys(
            value
          ).length;
        }

      } catch (error) {}

      return 0;
    }

    function update() {

      var count =
        getCount();

      counters.forEach(
        function (counter) {

          counter.textContent =
            String(count);

          counter.hidden =
            count < 1;
        }
      );
    }

    update();

    window.addEventListener(
      'storage',
      function (event) {

        if (
          event.key ===
          'vsx9_wishlist_v1'
        ) {
          update();
        }

      }
    );

    window.addEventListener(
      'vs:wishlist:updated',
      update
    );

    document.addEventListener(
      'vs:wishlist:updated',
      update
    );
  }

  /* =========================================================
     CART COUNT
  ========================================================= */

  function initCart(root) {

    var counters =
      root.querySelectorAll(
        '[data-vs-cart-count]'
      );

    if (
      !counters.length ||
      root.dataset
        .vsCartInitialized === 'true'
    ) {
      return;
    }

    root.dataset
      .vsCartInitialized =
      'true';

    function update() {

      fetch(
        getRoot() + 'cart.js',
        {
          headers: {
            Accept:
              'application/json'
          },
          credentials:
            'same-origin'
        }
      )

        .then(
          function (response) {
            return response.json();
          }
        )

        .then(
          function (cart) {

            var count =
              Number(
                cart.item_count
              ) || 0;

            counters.forEach(
              function (counter) {

                counter.textContent =
                  String(count);

                counter.hidden =
                  count < 1;
              }
            );

          }
        )

        .catch(
          function () {}
        );
    }

    update();

    document.addEventListener(
      'cart:updated',
      update
    );

    document.addEventListener(
      'cart:refresh',
      update
    );

    window.addEventListener(
      'vs:cart:updated',
      update
    );
  }

  /* =========================================================
     MAIN INIT
  ========================================================= */

  function init(root) {

    if (
      !root ||
      root.dataset.vsReady === 'true'
    ) {
      return;
    }

    root.dataset.vsReady =
      'true';

    initPredictiveSearch(root);
    initDrawer(root);
    initWishlist(root);
    initCart(root);
  }

  /* =========================================================
     BOOT
  ========================================================= */

  function boot(scope) {

    var container =
      scope || document;

    container
      .querySelectorAll(
        '[data-vs-header]'
      )
      .forEach(init);
  }

  /* =========================================================
     CLOSE SEARCH OUTSIDE
  ========================================================= */

  document.addEventListener(
    'click',
    function (event) {

      document
        .querySelectorAll(
          '[data-vs-predictive-search].is-open'
        )
        .forEach(
          function (dropdown) {

            var wrapper =
              dropdown.closest(
                '.vs-header__search, .vs-header__mobile-search'
              );

            if (
              !wrapper ||
              wrapper.contains(
                event.target
              )
            ) {
              return;
            }

            var input =
              wrapper.querySelector(
                '[data-vs-search-input]'
              );

            closeSearch(
              dropdown,
              input
            );
          }
        );
    }
  );

  /* =========================================================
     ESCAPE
  ========================================================= */

  document.addEventListener(
    'keydown',
    function (event) {

      if (
        event.key !== 'Escape'
      ) {
        return;
      }

      document
        .querySelectorAll(
          '[data-vs-header]'
        )
        .forEach(
          function (root) {

            if (
              root._vsCloseDrawer
            ) {
              root._vsCloseDrawer();
            }

            root
              .querySelectorAll(
                '[data-vs-predictive-search].is-open'
              )
              .forEach(
                function (dropdown) {

                  var wrapper =
                    dropdown.closest(
                      '.vs-header__search, .vs-header__mobile-search'
                    );

                  var input =
                    wrapper
                      ? wrapper.querySelector(
                          '[data-vs-search-input]'
                        )
                      : null;

                  closeSearch(
                    dropdown,
                    input
                  );
                }
              );
          }
        );
    }
  );

  /* =========================================================
     INITIAL LOAD
  ========================================================= */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function () {
        boot(document);
      }
    );

  } else {

    boot(document);

  }

  /* =========================================================
     SHOPIFY THEME EDITOR
  ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      var header =
        event.target &&
        event.target.querySelector
          ? event.target.querySelector(
              '[data-vs-header]'
            )
          : null;

      if (header) {

        header.dataset.vsReady =
          '';

        header.dataset
          .vsDrawerInitialized =
          '';

        header.dataset
          .vsWishlistInitialized =
          '';

        header.dataset
          .vsCartInitialized =
          '';

        header
          .querySelectorAll(
            '.vs-header__search-form'
          )
          .forEach(
            function (form) {
              form.dataset
                .vsSearchInitialized =
                '';
            }
          );

        init(header);
      }
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    function () {

      document.documentElement.classList.remove(
        'vs-header-menu-open'
      );

    }
  );

})();